export const Config = {
	type: 'offers',
	lengthNameDesktop: 35,
	lengthNameMobile: 45,
};
